import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Styled from 'styled-components'
import {
  StaticQuery,
  graphql
} from 'gatsby'

import Sidebar from './sidebar/index'
import Header from './header/index'
import SiteStore from '../stores/site-store';

import './layout.css'
import siteActions from '../actions/site-actions';

class Layout extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      menu: SiteStore.getMenuState()
    }

    this._onChange = this._onChange.bind(this)
    this.handleDocumentClick = this.handleDocumentClick.bind(this)

    SiteStore.addChangeListener(this._onChange);

    if (typeof document !== 'undefined') {
      document.addEventListener('click', this.handleDocumentClick);
    }
  }

  handleDocumentClick(e) {
    if (e.target.className.indexOf('sidebar__SidebarLink') !== -1) {
      siteActions.toggleMenu();
    }
  }

  componentWillUnmount() {
    SiteStore.removeChangeListener(this._onChange)
    if (typeof document !== 'undefined') {
      document.removeEventListener('click', this.handleDocumentClick)
    }
  }

  _onChange() {
    this.setState({
      menu: SiteStore.getMenuState()
    })
  }

  render() {
    return ( <
      StaticQuery query = {
        graphql `
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `
      }
      render = {
        data => {
          return ( <
            >
            <
            Helmet title = {
              data.site.siteMetadata.title
            }
            meta = {
              [{
                  name: 'description',
                  content: 'Shards React - A high-quality & free React UI kit featuring a modern design system with dozens of custom components.'
                },
                {
                  name: 'keywords',
                  content: 'react, ui kit, design system, modern, free'
                },
              ]
            } >
            <
            html lang = "en" / >
            <
            link rel = "stylesheet"
            href =
            "https://unpkg.com/bootstrap@4.1.3/dist/css/bootstrap.min.css" /
            >
            <
            link rel = "stylesheet"
            href =
            "https://unpkg.com/shards-ui@latest/dist/css/shards.min.css" /
            >
            <
            /Helmet>

            <
            Header siteTitle = {
              data.site.siteMetadata.title
            }
            />

            <
            ContentWrapper >
            <
            Sidebar state = {
              this.state.menu
            }
            /> <
            Content > {
              this.props.children
            } <
            /Content> <
            /ContentWrapper> <
            />
          )
        }
      }
      />
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout

const ContentWrapper = Styled.div `
  padding-top: 70px;
`

const Content = Styled.div `
  padding: 50px 20% 50px 90px;
  margin-left: 250px;
  transition: margin .15s ease-in-out;
  background: #fbfcfd;
  min-height: calc(100vh - 70px);

  > h1, > h2, > h3, > h4, > h5, > h6 {
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;
    font-weight: 600;
  }

  > h1 {
    margin-bottom: 30px;
  }

  @media (max-width: 780px) {
    width: 100% !important;
    margin-left: 0 !important;
  }

  @media (max-width: 500px) {
    padding: 50px !important;
  }
`
